var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section center"},[_c('span',{staticClass:"icon icon--block icon--large secondary fa-compass"}),_c('h1',{staticClass:"title title--1"},[_vm._v(" 404 ")]),_c('p',[_vm._v(" This page doesn't exist. ")])])
}]

export { render, staticRenderFns }